module.exports = __webpack_public_path__ + "img/x1.5_74f6a2591.png";